import createVueComponent from '../createVueComponent';

const Navigation2 = createVueComponent('Navigation2Icon', [
  ['polygon', { points: '12 2 19 21 12 17 5 21 12 2' }],
]);

export default Navigation2;
